import { Page, View, Text } from '@react-pdf/renderer';
import { styles } from './styles';
import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import { SafeImage } from '../../components/SafeImage';
import { useTranslation } from 'react-i18next';
import { globalStyles } from '../../styles';

export interface PartnershipOpportunityPageProps {
  event: PublicEventDetailsResponse;
  header: JSX.Element;
  footer: JSX.Element;
}

const PartnershipOpportunityPage = ({
  event,
  header,
  footer,
}: PartnershipOpportunityPageProps) => {
  const { t } = useTranslation();

  return (
    <Page size="A4" orientation="portrait" style={styles.page}>
      {header}

      <View style={styles.contentWrapper}>
        <Text
          style={{
            ...styles.title,
            color: event?.design?.themeColor,
          }}
        >
          {t('partnership-opportunity-title')}
        </Text>

        <View
          style={{
            ...globalStyles.lineBar,
            borderColor: event?.design?.themeColor ?? 'black',
            marginLeft: 0,
            marginBottom: 20,
            width: 89,
          }}
        />

        <Text style={styles.description}>
          {t('partnership-opportunity-text', {
            eventName: event?.name,
          })}
        </Text>

        <View style={styles.columnsWrapper}>
          <View style={styles.leftColumn}>
            <View style={{ display: 'flex', flexDirection: 'column', gap: 40 }}>
              {[1, 2, 3, 4, 5].map(item => {
                return (
                  <View key={`partnership-opportunity-item-${item}`}>
                    <Text
                      style={{
                        ...styles.itemTitle,
                        color: event?.design?.themeColor,
                      }}
                    >
                      {t(`partnership-opportunity-item-${item}-title`)}
                    </Text>
                    <Text style={styles.itemText}>
                      {t(`partnership-opportunity-item-${item}-text`)}
                    </Text>
                  </View>
                );
              })}
            </View>
          </View>

          <View style={styles.rightColumn}>
            <View
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 5,
              }}
            >
              <SafeImage
                style={styles.image}
                src={
                  'https://media.we-conect.com/images/pdf/agenda/pdf_agenda_partnership_1.png'
                }
              />
              <SafeImage
                style={styles.image}
                src={
                  'https://media.we-conect.com/images/pdf/agenda/pdf_agenda_partnership_2.png'
                }
              />
              <SafeImage
                style={styles.image}
                src={
                  'https://media.we-conect.com/images/pdf/agenda/pdf_agenda_partnership_3.png'
                }
              />
              <SafeImage
                style={styles.image}
                src={
                  'https://media.we-conect.com/images/pdf/agenda/pdf_agenda_partnership_4.png'
                }
              />
            </View>
          </View>
        </View>
      </View>

      {footer}
    </Page>
  );
};

export default PartnershipOpportunityPage;
